import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PresentationPage from './pages/PresentationPage';
import AccessCodePage from './pages/AccessCodePage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/access" element={<AccessCodePage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <PresentationPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App